/**
 * 콘솔 창에 메시지를 띄웁니다.
 */
function welcome() {
  console.info(
    `=== Looko-AI ===
- Version: ${_APP_VERSION}${_APP_GIT_SHA ? `+${_APP_GIT_SHA}` : ''}
- Build Date: ${new Date(_BUILD_TIME_MS).toLocaleString()}`,
  );
}

export default welcome;
